export default __webpack_public_path__ + "static/media/img4.8268f185.jpg";